//const API_BASE_URL = 'http://localhost:8000';
const API_BASE_URL = 'https://api.gvendas.app.br';
const SERVER_BASE_URL = 'https://go.gvendas.app.br';

const myDB = "gvendas";
const versaoDb = 24;
const TABELAS = [
  'db_sync', 'db_logs', 'local_registros',
  'db_clientes', 'db_pagamentos', 'db_produtos', 'db_vendas',
  'db_categorias', 'db_marcas', 'db_financas', 'db_pedidos', 'db_leads',
  'db_apresentacoes',
  'db_atalhos',
];

const buscaController = {};
let dbPromise = null;
let dbInstance = null;

function abrirIndexedDB() {
  if (dbInstance) return Promise.resolve(dbInstance);
  if (dbPromise) return dbPromise;

  dbPromise = new Promise((resolve, reject) => {
    const request = indexedDB.open(myDB, versaoDb);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      const transaction = event.target.transaction;
    
      const indicesPorTabela = {
        db_clientes: ['nome_do_cliente', 'total_em_pagamentos', 'data_ultima_compra'],
        db_pagamentos: ['data_do_pagamento', 'pago','venda.id', 'item.venda.cliente.ativo', 'item.venda.cliente.is_inadimplente'],
        db_vendas: ['data_da_venda','cliente.id'],
        db_pedidos: ['data_do_pedido'],
        db_financas: ['data'],
        db_leads: ['data_atualizacao'],
        db_produtos: ['nome_do_produto'],
        db_marcas: ['nome_da_marca'],
        db_categorias: ['nome_da_categoria'],
        db_sync: ['data'],
        db_logs: ['data'],
      };
    
      TABELAS.forEach((nomeTabela) => {
        let store;
        if (!db.objectStoreNames.contains(nomeTabela)) {
          store = db.createObjectStore(nomeTabela, { keyPath: 'id', autoIncrement: true });
        } else {
          store = transaction.objectStore(nomeTabela);
        }
    
        const indices = indicesPorTabela[nomeTabela] || [];
        indices.forEach((indice) => {
          const indiceFormatado = indice.replace(/\./g, "_");
          if (!store.indexNames.contains(indiceFormatado)) {
            store.createIndex(indiceFormatado, indice, { unique: false });
          }
        });
      });
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      dbInstance = db;

      db.onversionchange = () => {
        db.close();
        dbInstance = null;
        dbPromise = null;
      };

      db.onclose = () => {
        dbInstance = null;
        dbPromise = null;
      };

      resolve(db);
    };

    request.onerror = (event) => {
      dbPromise = null;
      reject(tratarErroIndexedDB(event.target.error, 'abrirIndexedDB'));
    };

    request.onblocked = () => {
      console.warn("Atualização do banco bloqueada");
    };
  });

  return dbPromise;
}

function tratarErroIndexedDB(error, contexto = '') {
  console.error(`Erro IndexedDB ${contexto ? `em ${contexto}` : ''}:`, error);
  if (
    error?.name === "QuotaExceededError" ||
    error?.message?.toLowerCase().includes("quota") ||
    error?.message?.toLowerCase().includes("storage")
  ) {
    return { tipo: 'quota', mensagem: 'Espaço de armazenamento excedido.' };
  }
  return { tipo: 'geral', mensagem: error?.message || 'Erro inesperado no IndexedDB.' };
}

function fecharIndexedDB() {
  if (dbInstance) {
    dbInstance.close();
    dbInstance = null;
    dbPromise = null;
  }
}

async function tratarLimiteIndexedDB(error, tabela, dados) {
  if (error.tipo !== "quota") return;
  const tabelasParaLimpar = TABELAS.filter(t => !["db_sync", "local_registros"].includes(t));
  await excluirDados(tabelasParaLimpar);
  await salvarDados(tabela, dados);
}

async function salvarDados(tabela, dados) {
  try {
    const lista = Array.isArray(dados) ? dados : [dados];
    const db = await abrirIndexedDB();
    const tx = db.transaction(tabela, 'readwrite');
    const store = tx.objectStore(tabela);

    for (const item of lista) {
      if (item) store.put(item);
    }

    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tratarErroIndexedDB(tx.error, `salvarDados(${tabela})`));
    });
  } catch (error) {
    if (error.tipo === 'quota') {
        await tratarLimiteIndexedDB(error, tabela, dados);
        return true;
    }
    throw tratarErroIndexedDB(error, `salvarDados(${tabela})`);
  }
}

async function buscarDados(
  tabela,
  filtroFunc = null,
  limite = 20,
  indice = null,
  ordem = 'asc',
  pagina = 1
) {
  try {
    const idBusca = Date.now();
    buscaController[tabela] = idBusca;

    const db = await abrirIndexedDB();

    return new Promise((resolve, reject) => {
      const tx = db.transaction(tabela, 'readonly');
      const store = tx.objectStore(tabela);
      const direcao = ordem === 'desc' ? 'prev' : 'next';
      const fonte = indice && store.indexNames.contains(indice) ? store.index(indice) : store;
      const request = fonte.openCursor(null, direcao);
      const resultado = [];

      const paginaSegura = Math.max(1, Number(pagina) || 1);
      const limiteSeguro = Math.max(0, Number(limite) || 0);
      const offset = (paginaSegura - 1) * limiteSeguro;

      let matched = 0;

      request.onsuccess = (event) => {
        if (buscaController[tabela] !== idBusca) return;

        const cursor = event.target.result;
        if (!cursor) {
          resolve(resultado);
          return;
        }

        const item = cursor.value;
        const ok = typeof filtroFunc === "function" ? !!filtroFunc(item) : true;

        if (ok) {
          if (matched < offset) {
            matched++;
            cursor.continue();
            return;
          }

          resultado.push(item);
          if (limiteSeguro && resultado.length >= limiteSeguro) {
            buscaController[tabela] = 0;
            resolve(resultado);
            return;
          }
        }

        cursor.continue();
      };

      request.onerror = () => {
        reject(tratarErroIndexedDB(request.error, `buscarDados(${tabela})`));
      };
    });
  } catch (error) {
    throw tratarErroIndexedDB(error, `buscarDados(${tabela})`);
  }
}

async function buscarDadosPorId(tabela, id) {
  try {
    const db = await abrirIndexedDB();
    const tx = db.transaction(tabela, 'readonly');
    const store = tx.objectStore(tabela);
    const request = store.get(id);

    return new Promise((resolve, reject) => {
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(tratarErroIndexedDB(request.error, `buscarDadosPorId(${tabela})`));
    });
  } catch (error) {
    throw tratarErroIndexedDB(error, `buscarDadosPorId(${tabela})`);
  }
}

async function buscarVariosDadosPorIds(tabela, ids = []) {
  try {
    if (!ids.length) return [];

    let idsLimpos = ids;
    if (typeof ids[0] === 'object' && ids[0] !== null && 'id' in ids[0]) {
      idsLimpos = ids.map(item => item.id);
    }

    const db = await abrirIndexedDB();
    const tx = db.transaction(tabela, 'readonly');
    const store = tx.objectStore(tabela);

    const promises = idsLimpos.map(id => {
      return new Promise((resolve, reject) => {
        const request = store.get(id);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject(tratarErroIndexedDB(request.error, `buscarVariosDadosPorIds(${tabela})`));
      });
    });

    return (await Promise.all(promises)).filter(item => item !== null);
  } catch (error) {
    throw tratarErroIndexedDB(error, `buscarVariosDadosPorIds(${tabela})`);
  }
}

async function contarItensIndexedDB(tabela) {
  try {
    const db = await abrirIndexedDB();
    const tx = db.transaction(tabela, 'readonly');
    const store = tx.objectStore(tabela);

    return new Promise((resolve, reject) => {
      const request = store.count();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(tratarErroIndexedDB(request.error, `contarItensIndexedDB(${tabela})`));
    });
  } catch (error) {
    throw tratarErroIndexedDB(error, `contarItensIndexedDB(${tabela})`);
  }
}

async function excluirDadosCompleto() {
  const site = await buscarDadosPorId("local_registros", "site");
  const loja = await buscarDadosPorId("local_registros", "loja");
  await excluirDados(TABELAS);
  await salvarDados("local_registros",[
    {
      ...site,
      id:"site"
    },
    {
      ...loja,
      id:"loja"
    },
  ])
}

async function excluirDados(tabelas) {
  try {
    const lista = Array.isArray(tabelas) ? tabelas : [tabelas];
    const db = await abrirIndexedDB();

    for (const tabela of lista) {
      const tx = db.transaction(tabela, 'readwrite');
      const store = tx.objectStore(tabela);
      store.clear();
      await new Promise((resolve, reject) => {
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tratarErroIndexedDB(tx.error, 'excluirDados'));
      });
    }
  } catch (error) {
    throw tratarErroIndexedDB(error, 'excluirDados');
  }
}

async function excluirDadosPorId(tabela, dados) {
  try {
    const db = await abrirIndexedDB();
    const tx = db.transaction(tabela, 'readwrite');
    const store = tx.objectStore(tabela);

    const ids = Array.isArray(dados)
      ? dados.map(item => (typeof item === 'object' ? item.id : item))
      : [typeof dados === 'object' ? dados.id : dados];

    ids.forEach(id => store.delete(id));

    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tratarErroIndexedDB(tx.error, `excluirDadosPorId(${tabela})`));
    });
  } catch (error) {
    throw tratarErroIndexedDB(error, `excluirDadosPorId(${tabela})`);
  }
}

function excluirBanco() {
  dbPromise = null;
  dbInstance = null;
  return indexedDB.deleteDatabase(myDB);
}

export {
  API_BASE_URL,
  SERVER_BASE_URL,
  salvarDados,
  buscarDados,
  buscarDadosPorId,
  buscarVariosDadosPorIds,
  excluirDados,
  excluirDadosCompleto,
  excluirDadosPorId,
  excluirBanco,
  contarItensIndexedDB,
};
